import { trpc, queryClient } from "~/utils/trpc";
import { Button } from "@quake/shared-ui/components/ui/button";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import DraftingCompassIcon from "lucide-react/dist/esm/icons/drafting-compass";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/email-settings/")({
  component: RouteComponent,
});
function RouteComponent() {
  const { datasetSlug } = Route.useParams();

  useBreadCrumbs([
    {
      title: "Email Settings",
      link: `/${datasetSlug}/settings/email-settings`,
    },
  ]);

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: trpc.emailSettings.getAll.pathKey() });
  }, []);

  return (
    <div>
      <div className="text-right">
        <Link to="/$datasetSlug/settings/email-settings/templates" params={{ datasetSlug }}>
          <Button>
            <DraftingCompassIcon /> Configure Templates
          </Button>
        </Link>
      </div>
    </div>
  );
}
